import { useMutation } from '@tanstack/react-query';
import { APIClinicBilling } from 'lib/api/firebase/apis/api-clinic-balance';

export interface CreateCheckoutSessionVariables {
  clinicId: string;
  productId: string;
  redirectUrl: string;
}

/**
 * A mutation to create a Stripe checkout session for a specific product ID.
 */
export function useCreateCheckoutSessionMutation() {
  return useMutation({
    mutationFn: async (variables: CreateCheckoutSessionVariables) => {
      return APIClinicBilling.createCheckoutSession({
        clinicId: variables.clinicId,
        productId: variables.productId,
        redirectUrl: variables.redirectUrl,
      });
    },
    onError: (error) => {
      console.error('Create checkout session failed:', error);
    },
  });
}
